import { useEffect, useState } from 'react';
import axiosInstance from '../../variables/api/axiosInstance';
import { REGLAGES_PAR_DEFAUT, CLES_PARAMETRES } from './indiceReedition';

/**
 * Réglages des indices de réédition, lus une fois puis partagés.
 *
 * Les trois documents imprimables en ont besoin. Sans ce cache, ouvrir la fiche
 * puis les deux attestations déclencherait trois appels identiques ; et comme un
 * paramètre système ne bouge qu'à la main depuis un écran d'administration, le
 * relire à chaque ouverture n'apporterait rien.
 *
 * En cas d'échec, on retombe sur les valeurs par défaut - donc sur l'absence
 * d'indice. Un document imprimé sans sa marque vaut mieux qu'un écran bloqué.
 */
let cache = null;
let enVol = null;

const lire = () => {
  if (cache) return Promise.resolve(cache);
  if (enVol) return enVol;

  enVol = axiosInstance.get('/v1/parametres', { skipErrorToast: true })
    .then((res) => {
      const tous = res?.data?.data || [];
      const valeur = (cle) => tous.find((p) => p.cle === cle)?.valeur;
      const actif = (cle, defaut) => {
        const v = valeur(cle);
        return v === undefined || v === null || v === '' ? defaut : String(v) === 'true';
      };

      cache = {
        modificationActif: actif(CLES_PARAMETRES.modificationActif, REGLAGES_PAR_DEFAUT.modificationActif),
        modificationLibelle: valeur(CLES_PARAMETRES.modificationLibelle) || REGLAGES_PAR_DEFAUT.modificationLibelle,
        impressionActif: actif(CLES_PARAMETRES.impressionActif, REGLAGES_PAR_DEFAUT.impressionActif),
        impressionLibelle: valeur(CLES_PARAMETRES.impressionLibelle) || REGLAGES_PAR_DEFAUT.impressionLibelle,
      };
      return cache;
    })
    .catch(() => REGLAGES_PAR_DEFAUT)
    .finally(() => { enVol = null; });

  return enVol;
};

/** Vide le cache : appelé après un enregistrement depuis l'écran de paramètres. */
export const oublierReglagesIndices = () => { cache = null; };

export function useReglagesIndices() {
  const [reglages, setReglages] = useState(cache || REGLAGES_PAR_DEFAUT);

  useEffect(() => {
    let ignore = false;
    lire().then((r) => { if (!ignore) setReglages(r); });
    return () => { ignore = true; };
  }, []);

  return reglages;
}
